<template>
  <div>
    <div>일정 선택</div>
    <div>
      <div style="padding:16px">
        <lp-check-bool label="종일 예약 가능한 날만 보기" :checkedVal.sync="vAllTime"></lp-check-bool>

        <div class="bg-white" style="padding:12px;border-radius:4px">
          <!-- 연,월 -->
          <div class="flex-center" style="margin-bottom:8px">
            <div class="flex-align">
              <i class="material-icons icon-arrow unselect" @click="clickPrev">keyboard_arrow_left</i>
              <div class="lp-month">{{ `${this.currentDate.year()}년 ${this.currentDate.month()+1}월` }}</div>
              <i class="material-icons icon-arrow unselect" @click="clickNext">keyboard_arrow_right</i>
            </div>
          </div>
          <!-- 요일 -->
          <div class="flex lp-days">
            <div class="lp-day"
                 v-for="(day,idx) in days" :key="'day-'+idx">{{ day }}</div>
          </div>
          <!-- 일 -->
          <div class="flex wrap lp-dates">
            <div class="lp-date unselect"
                 v-for="(date,idx) in dates" :key="'date-'+idx">
              <!-- 일자 표시 -->
              <div :style="dayStyle(date)" @click="clickDate(date)">{{ date.day > 0 ? date.day : '' }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 예약 일정 -->
      <div v-for="(resv,idx) in resvs" :key="'resv-'+idx"
           class="grid-box box-resv" :style="boxStyle(resv)" @click="clickResv(resv)">
        <div class="col-6">
          <div v-if="resv.all_time" class="color-main size-14" style="margin-bottom:4px">종일 예약</div>
          <div v-else class="color-main size-14" style="margin-bottom:4px">{{ `${resv.start_time} ~ ${resv.end_time}`}}</div>
          <div class="color-sub size-12">잔여 {{ `${resv.remain} / ${resv.stock}` }}</div>
        </div>
        <div class="col-6 flex-end">
          <div v-if="resv.remain===0">마감</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LpCheckBool from "../../../../module/common/LpCheckBool";
  export default {
    name: "ScheduleOverlay",
    components: {LpCheckBool},
    props: {
      productId: {
        type: Number
      }
    },
    data() {
      return {
        "max": 1,
        "days": [
          "일",
          "월",
          "화",
          "수",
          "목",
          "금",
          "토"
        ],
        "dates": [],
        "resvs": [],
        "vAllTime": false,
        "currentDate": undefined,
        "ordered_count": 1
      }
    },
    created() {
      this.currentDate = this.moment();
      this.setDates();
    },

    methods: {
      clickResv(resv) {
        if(resv.remain === 0) return;
        this.$emit('selectedResv', resv);

      },
      clickDate(date) {
        if(!date.enable || date.prev) {
          return;
        }
        this.dates.forEach(date => { date.selected = false; });
        date.selected = true;
        this.resvs = [];
        if(date.all_time) {
          this.resvs = [{
            org_start_date: '%d-%02d-%02d'.format(date.year, date.month, date.day),
            all_time: true,
            stock: date.stock,
            remain: date.remain
          }];
        } else {
          this.resvs = date.times;
        }
        this.resvs.forEach(item => {
          item.selected = false;
          item.org_start_date = '%d-%02d-%02d'.format(date.year, date.month, date.day);
        });
      },
      clickNext() {
        this.currentDate.add(1, 'months');
        this.setDates();
      },
      clickPrev() {
        this.currentDate.subtract(1, 'months');
        this.setDates();
      },
      boxStyle(resv) {
        let deco = {
          backgroundColor: '#ffffff'
        };

        if(resv.remain===0) {
          deco.backgroundColor = '#eee';
          deco.color = '#999';
        }

        return deco;
      },
      dayStyle(date) {
        let deco = {
          borderRadius: '50%',
          color: 'white',
          width: '36px',
          height: '36px',
          lineHeight: '36px',
          textAlign: 'center'
        };

        if(date.prev) {
          deco.color = '#e4dde4';
        }
        else if(!date.enable) {
          deco.color = '#e4dde4';
        }
        else if(date.selected) {
          deco.backgroundColor = '#ff5722';
          deco.color = 'white';
        }
        else {
          deco.color = '#515151';
        }
        deco.fontSize = '13px';

        return deco;
      },
      setDates() {
        this.resvs = [];
        this.dates = [];
        let day = 0;
        let year = this.currentDate.year();
        let month = this.currentDate.month()+1;
        let start_day = this.currentDate.startOf('month').day();
        let end_date = this.currentDate.endOf('month').date();
        let len = 42;
        if(start_day + end_date <= 35) {
          len = 35;
        }

        // 이전달 날짜
        for(let i=start_day-1; i>=0; i--) {
          let old = this.moment(this.currentDate);
          old.subtract(1, 'month');
          let old_last = old.endOf('month').date();

          this.dates.push({
            year: old.year(),
            month: old.month()+1,
            day: old_last - i,
            prev: true
          });
        }

        for(let i=0; i< len; i++) {
          if(i>=start_day && day<end_date) {
            let date = {
              year: year,
              month: month,
              day: ++day,
              enable: false,
            };
            date.prev = this.moment('%d-%02d-%02d'.format(year,month,day+1)).isBefore(this.moment());

            this.dates.push(date);
          }
        }

        // 다음달 날짜
        for(let i=1; i<=(len-end_date-start_day); i++) {
          let next = this.moment(this.currentDate);
          next.add(1, 'month');

          this.dates.push({
            year: next.year(),
            month: next.month()+1,
            day: i,
            prev: true
          });
        }

        let date = `${this.currentDate.year()}-${this.currentDate.month()+1}`;

        let url = `public/product/${this.productId}/schedule/monthly/${date}`;
        this.$axios.get(url).then(res => {
          res.data.dates.forEach(item => {
            if(item.day>0) {
              if(item.times.length>0) {
                item.times = item.times.filter(time => {
                  return !time.break_time
                });

                item.times.forEach(item => {
                  item.selected = false;
                });
                let date = this.dates.filter(date => {
                  return date.year === item.year &&
                    date.month === item.month &&
                    date.day === item.day;
                })[0];

                date.enable = true;
                date.times = item.times;
                // 잔여석이 없는 경우 비활성
                if(date.times.filter(time => { return time.remain > 0 }).length === 0) {
                  date.enable = false;
                }
                // 종일에 체크된 경우 비활성
                if(this.vAllTime) {
                  date.enable = false;
                }

              }
              // 종일 설정된 날짜
              if(item.all_time) {
                let date = this.dates.filter(date => {
                  return date.year === item.year &&
                    date.month === item.month &&
                    date.day === item.day;
                })[0];
                date.all_time = true;
                date.enable = item.remain > 0;
                date.remain = item.remain;
                date.stock = item.stock;
              }
            }
          });

        });
      }
    },
    computed: {

    },
    watch: {
      vAllTime() {
        this.setDates();
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .bg-white
    background-color white
  .color-main
    color #333333
  .color-sub
    color #989898

  .size-12
    font-size 12px
  .size-14
    font-size 14px
  .lp-month
    font-size 15px
    margin 0 12px

  .lp-days
    padding 12px 0
    border-bottom 1px solid #ddd
    margin-bottom 12px

  .lp-day
    width 14.2857%
    text-align center
    padding-bottom 4px
    font-size 13px

  .lp-dates
    margin-bottom 20px

  .lp-date
    width 14.2857%
    display flex
    justify-content center
    padding 8px 0

  .icon-arrow
    color #fff
    background-color #777
    border-radius 50%
    font-size 18px

  .box-resv
    padding 16px
    border-top 1px solid #ddd

  .box-resv:hover
    background-color #f0f0f0 !important


</style>
